import { Component, OnInit } from '@angular/core';
import { AppService } from '../app.service';
import { Router } from '@angular/router';

import { TranslationService } from '../translate';

import $ from 'jquery';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  changeTrigger: boolean = false;

  // Application Object
  deceased_default = {};
  // deceased = this.appState.get();
  deceased = this.appState.resetHome();

  // Wife Temp Object
  permanent_divorced_marriages_last_values = new Array(); // Deceased Wife Inheritance Last saved Values
  temp_marriages_last_values = new Array(); // Deceased Wife Inheritance Last saved Values
  divorced_last_values = new Array(); // Deceased Wife Inheritance Last saved Values

  // Son & Daughters temp Object
  sons_last_values = new Array(); // Deceased Wife Inheritance Last saved Values
  daughters_last_values = new Array(); // Deceased Wife Inheritance Last saved Values

  // Settings
  settings = localStorage.getItem('settings');

  constructor(private _trans: TranslationService, public appState: AppService, public router: Router) {
    this._trans.getDataFile();
    this.appState = this.appState;

    if( this.settings != null ) {
      var settingsLocal = JSON.parse( this.settings );  

      if( settingsLocal.lang == "" ) {
        this.router.navigate(['settings']);
      }
    } else {
      this.router.navigate(['settings']);
    }

    // Save Default values in Object
    this.deceased_default = this.appState.get();

    // Load value from LocalStorage if values are empty
    if( this.deceased.empty == true ) {
      var last_saved_values = localStorage.getItem('deceased');

      if( last_saved_values ) {
        this.deceased = JSON.parse(last_saved_values);
      }
    }
  }

  ngOnInit() {

    // Reset Calculation if page contains Previously calculated deceased information.
    if( this.deceased.gender != '' ) {
      location.reload();
    }

    this.deceased.name = this._trans.instant(this.deceased.name);


    // Trigger Gender Change
    this.optionChanged('gender');
  }


  // Application Code starts here
  martial_status_options = ['Never Married', 'Other'];

  // When any Select box is Changed
  optionChanged(type) {

    if( type == "gender" ) {
      if( this.deceased.gender == "Female" ) {
        this.martial_status_options = ['Never Married', 'Permanent', 'Temporary', 'Divorced', 'Other']
      } else {
        this.martial_status_options = ['Never Married', 'Other']
      }
    }

  }


  // When Survivor Radio button is changed
  survivorChange(event) {

    this.totalSonsChange(event);
    this.totalDaughtersChange(event);
    this.deceased.unborn_child == "";

    /*if( this.deceased.survivors == 'false' ) {
      this.deceased.son.count == 0;
      this.deceased.daughter.count == 0;
    }*/

  }


  /* Wife Count Changes */
  totalTempMarriageChange(event: any) {

    if( this.deceased.wife.temp.count == 0 ) { // Zero
      this.temp_marriages_last_values = this.deceased.wife.temp.inheritance_condition = new Array();

    } else if( this.deceased.wife.temp.count > 0 ) { // Greater Than Zero
      
      this.deceased.wife.temp.inheritance_condition = new Array();

      for (var i = 0; i < this.deceased.wife.temp.count; ++i) {
        if( this.temp_marriages_last_values[i] ) {
          this.deceased.wife.temp.inheritance_condition.push( this.temp_marriages_last_values[i] );
        } else {
          this.deceased.wife.temp.inheritance_condition.push('false');
        }
      }

      // Save Temp Marriage Count in Array
      this.temp_marriages_last_values = this.deceased.wife.temp.inheritance_condition;

    }

  }


  /* Permanent Marriage Count Change */
  totalPermanentDivorceMarriageChange(event: any) {

    if( this.deceased.wife.permanent.count == 0 && this.deceased.wife.divorced.count == 0 ) { // Zero
      this.permanent_divorced_marriages_last_values = this.deceased.wife.level1_wives = new Array();
      this.deceased.wife.level1_wives = new Array();

    } else if( this.deceased.wife.permanent.count > 0 || (this.deceased.wife.divorced.count > 0) ) { // Greater Than Zero
      
      this.deceased.wife.level1_wives = new Array();


      // Permanent Wives
      for (var i = 0; i < this.deceased.wife.permanent.count; ++i) {
        if( this.permanent_divorced_marriages_last_values[i] ) {
          this.deceased.wife.level1_wives.push( this.permanent_divorced_marriages_last_values[i] );
        } else {
          
          var emptyObj = {
            name: "Permanent Wife "+ (i+1),
            type: "permanent",
            eligibility: "",
            muslim: "", 
            deceased_killer: "", 
            free_person: "true",
            terminal_illness: "",
            consummated: ""
          };

          this.deceased.wife.level1_wives.push(emptyObj);
        }
      }


      // In Iddah-e-Talaq or Talaq-Rijee
      if( this.deceased.wife.divorced.iddah_rijee_count > 0 ) {
        for (var j = 0; j < this.deceased.wife.divorced.iddah_rijee_count; ++j) {
          
            var emptyObj = {
              name: "Wife in Iddah " + (j+1),
              type: "iddah",
              eligibility: "",
              muslim: "", 
              deceased_killer: "", 
              free_person: "true",
              terminal_illness: "",
              consummated: ""
            };

            this.deceased.wife.level1_wives.push(emptyObj);
        }
      }

      // Within one Lunar year of Talaq.. he was sick
      if( this.deceased.wife.divorced.during_sick > 0 ) {

        for (var k = 0; k < this.deceased.wife.divorced.during_sick; ++k) {

          var kt = 0;  
          // If All Conditions are met, then add the Wife to Level1 Inheritance List
          if( this.deceased.wife.divorced.wives[k].wife_remarried == "true" && 
            this.deceased.wife.divorced.wives[k].divorce_wanted_by_wife == "true" &&
            this.deceased.wife.divorced.wives[k].husband_died_in_same_illness == "true") {
        
                var emptyObj = {
                  name: "Wife divorced in Sickness "+ (k+1),
                  type: "sick",
                  eligibility: "",
                  muslim: "", 
                  deceased_killer: "", 
                  free_person: "true",
                  terminal_illness: "",
                  consummated: ""
                };

                this.deceased.wife.level1_wives.push(emptyObj);

              kt++;
          }


        }
      }

      // Save Temp Marriage Count in Array
      this.permanent_divorced_marriages_last_values = this.deceased.wife.level1_wives;

    }
  }



  /* Total Son Count Change */
  totalSonsChange(event: any) {
    
    if( this.deceased.survivors == 'false' ) {
      this.deceased.son.count = 0;
    }

    if( this.deceased.son.count == 0 || this.deceased.survivors == 'false' ) { // Zero
      this.sons_last_values = this.deceased.son.object = new Array();
    
    } else if( this.deceased.son.count > 0 ) { // Greater Than Zero
      
      this.deceased.son.object = new Array();

      for (var i = 0; i < this.deceased.son.count; ++i) {
        if( this.sons_last_values[i] ) {
          this.deceased.son.object.push( this.sons_last_values[i] );
        } else {
          
          var emptyObj = {
            name: "Son "+ ( this.deceased.son.count > 1 ? i+1 : ''),
            eligibility: "",
            muslim: '', 
            legitimate: '', 
            deceased_killer: '', 
            free_person: 'true',
            disowned: ''
          };

          this.deceased.son.object.push(emptyObj);
        }
      }

      // Save Temp Marriage Count in Array
      this.sons_last_values = this.deceased.son.object;

    }
    
  }

  /* Total Son Count Change */
  totalDaughtersChange(event: any) {

    if( this.deceased.survivors == 'false' ) {
      this.deceased.daughter.count = 0;
    }

    if( this.deceased.daughter.count == 0 || this.deceased.survivors == 'false' ) { // Zero
      this.daughters_last_values = this.deceased.daughter.object = new Array();
    
    } else if( this.deceased.daughter.count > 0 ) { // Greater Than Zero
      
      this.deceased.daughter.object = new Array();

      for (var i = 0; i < this.deceased.daughter.count; ++i) {
        if( this.daughters_last_values[i] ) {
          this.deceased.daughter.object.push( this.daughters_last_values[i] );
        } else {
          
          var emptyObj = {
            name: "Daughter "+ ( this.deceased.daughter.count > 1 ? i+1 : ''),
            eligibility: "",
            muslim: '', 
            legitimate: '', 
            deceased_killer: '', 
            free_person: 'true',
            disowned: ''
          };

          this.deceased.daughter.object.push(emptyObj);
        }
      }

      // Save Temp Marriage Count in Array
      this.daughters_last_values = this.deceased.daughter.object;

    }
    
  }


  // Form Validation
  formValidate() {

    // Step#1: Required Inputs and Selects   
    var inputs = document.querySelectorAll(".main_step.active .step.active *[required]");

    if( inputs.length > 0 ) {
      for (var i = 0; i < inputs.length; ++i) {
        var input_elem = <HTMLInputElement>inputs[i];

        if( input_elem.value == '' ) {
          inputs[i].parentElement.classList.add("has-error");  
          input_elem.focus();

          $('html, body').animate({
              scrollTop: $( ".has-error" ).offset().top
          }, 500);

          return false;
        
        } else {
          inputs[i].parentElement.classList.remove("has-error");  
        }
      }
    }



    // Step#2: Check Radio Buttons whether they are checked or not
    var error = false;
    var radio_buttons_wrap = document.querySelectorAll(".main_step.active .step.active .radio-buttons-wrap");

    for (var i = 0; i < radio_buttons_wrap.length; ++i) {
      var radio = radio_buttons_wrap[i].querySelectorAll("input[type='radio']");
      var checked = false;
      
      for (var k = 0; k < radio.length; ++k) {
        var radio_elem = <HTMLInputElement>radio[k];

        if( radio_elem.checked ) {
          checked = true;
          break;
        }
      }

      if( ! checked ) {
        radio_buttons_wrap[i].parentElement.classList.add("has-error");

        $('html, body').animate({
            scrollTop: $( ".has-error" ).offset().top
        }, 500);

        return false;

      } else {
        radio_buttons_wrap[i].parentElement.classList.remove("has-error");
      }
    }


    return true;
  }


  // Check Not Support Result 
  checkNotSupported() {

    
    // Not Supported Screen If Calculation is not possible
    if( (this.deceased.religion == 'Other') || 
      (this.deceased.gender == 'Unknown') || 
      (this.deceased.wife.pregnant == "true") ||
      (this.deceased.unborn_child == "true") ||
      (this.deceased.converted_islam == "true") ||
      (this.deceased.survivors == "true" && this.deceased.son.count == 0 && this.deceased.daughter.count == 0 ) ||
      (this.deceased.father.alive == 'false' && this.deceased.mother.alive == 'false' && (this.deceased.survivors == 'false' || (this.deceased.survivors == 'true' && (this.deceased.survivors == 'true' && this.deceased.son.count == 0) && (this.deceased.survivors == 'true' && this.deceased.daughter.count == 0)))) ||
      (this.deceased.martial_status == "Temporary" && this.deceased.husband.inheritance_condition == "true") ) {

      return true;
    
    } else {
      return false;
          
    }

  }


  // Next Button is clicked
  next(event) {

    // Form Validation
    if( this.formValidate() == false ) {
      return;
    }

    // Save Values
    this.appState.set(this.deceased);

    // If Calculation is not supported
    if( this.checkNotSupported() == true ) {
      this.router.navigate(['not-supported']);
      event.preventDefault();
      return false;
    }

    if( this.deceased.gender == 'Male' && this.deceased.martial_status != 'Never Married' && this.deceased.martial_status != '' ) {
      
      if( this.deceased.wife.temp.count > 0 ) {
        this.router.navigate(['wife/temp']);
      
      } else if( this.deceased.wife.divorced.count > 0 ) {
        this.router.navigate(['wife/divorced']);

      } else {
          this.router.navigate(['level1-inheritors']);
      }

    } else {
        this.router.navigate(['level1-inheritors']);
    }
    
    event.preventDefault();
    return false;

  }

}
